export const constants = {
    "cvssV3": "CVSS v3 Score",
    "cvssV2": "CVSS v2 Score",
    "Base Score" : "Base Score",
    "vulID" : "Vulnerability ID",
    "plugin": "Plugin ID",
    "baseScoreMetrics": "Base Score Metrics",
    "baseScoreExploitabilityMetrics": "Exploitability Metrics",
    "attackComplexity": "Attack Complexity",
    "scope": "Scope",
    "attackVector": "Attack Vector",
    "userInteraction": "User Interaction",
    "baseScoreImpactMetrics": "Impact Metrics",
    "confidentialityImpact": "Confidentiality Impact",
    "availabilityImpact": "Availability Impact",
    "integrityImpact": "Integrity Impact",
    "temporalScoreMetrics": "Temporal Score Metrics",
    "reportConfidence": "Report Confidence",
    "remediationLevel": "Remediation Level",
    "exploitCodeMaturity": "Exploit Code Maturity",
    "environmentalScoreMetrics": "Environmental Score Metrics",
    "environmentalScoreExploitabilityMetrics": "Exploitability Metrics",
    "userIntegration": "User Integration",
    "attackComplexity": "Attack Complexity",
    "privilegesRequired": "Privileges Required",
    "impactSubScoreModifiers": "Impact Sub Score Modifiers",
    "'availabilityRequirement": "Availability Requirement",
     "confidentialityRequirement": "Confidentiality Requirement",
     "integrityRequirement": "Integrity Requirement",
     "environmentalScoreImpactMetrics": "Impact Metrics",
     "availabilityRequirement": "Availability Requirement",
     "accessComplexity": "Access Complexity",
     "accessVector": "Access Vector",
     "authentication": "Authentication",
     "exploitabilityMetrics": "Exploitability Metrics",
     "impactMetrics": "Impact Metrics",
     "accessComplexity": "Access Complexity",
     "authentication": "Authentication",
     "exploitability": "Exploitability",
     "generalModifiers": "General Modifiers",
     "targetDistribution": "Target Distribution",
     "collateralDamagePotential": "Collateral Damage Potential"

}


